"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FormGroup_1 = require("./FormGroup");
const RadioGroup_1 = require("../radioGroup/RadioGroup");
const { root: formGroupRoot } = FormGroup_1.formGroupClasses;
const { root: radioGroupRoot } = RadioGroup_1.radioGroupClasses;
const MuiFormGroupOverrides = {
    MuiFormGroup: {
        styleOverrides: {
            root: {
                [`&.${formGroupRoot}.${radioGroupRoot}`]: {
                    paddingLeft: '8px'
                }
            },
        },
    },
};
exports.default = MuiFormGroupOverrides;
//# sourceMappingURL=MuiFormGroupOverrides.js.map